export const HOTKEY_DOCS_MULTIPLE_SELECTION = 'HOTKEY_DOCS_MULTIPLE_SELECTION'

export const documentsListHotkeys = Object.freeze({
    multipleSelection: {
        key: HOTKEY_DOCS_MULTIPLE_SELECTION,
        title: 'Multiple selection',
        description: 'For multiple selections, hold Shift and select the document “from” and “to”',
        hotkey: 'shift' // see custom handler in DocumentsViewList.vue
    }
})
